import { inject, Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { NotificationLevel } from '../../shared/models/notification-level.enum';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastr = inject(ToastrService);

  public userNotifications: Notification[] = [];

  public show: Record<
    NotificationLevel,
    (message: string, title?: string, options?: Partial<IndividualConfig>) => void
  > = {
    [NotificationLevel.SUCCESS]: this.success.bind(this),
    [NotificationLevel.INFO]: this.info.bind(this),
    [NotificationLevel.WARNING]: this.warning.bind(this),
    [NotificationLevel.ERROR]: this.error.bind(this),
  };

  public success(message: string, title?: string, options?: Partial<IndividualConfig>): void {
    this.toastr.success(message, title, options);
  }

  public error(message: string, title?: string, options?: Partial<IndividualConfig>): void {
    this.toastr.error(message, title, options);
  }

  public info(message: string, title?: string, options?: Partial<IndividualConfig>): void {
    this.toastr.info(message, title, options);
  }

  public warning(message: string, title?: string, options?: Partial<IndividualConfig>): void {
    this.toastr.warning(message, title, options);
  }
}
